// extracted by mini-css-extract-plugin
export var circle = "_ft-1";
export var exitConfirmationModal = "_ft-5";
export var iframe = "_ft-0";
export var offline = "_ft-3";
export var online = "_ft-2";
export var workstationSelectError = "_ft-4";